export default {
  TITLE: `Ton horaire a été publié`,
  SUMMARY: ``,
  PRIMARY_ACTION: `J'ai pris connaissance de mes quarts`,
  POSITION: `Position`,
  START: `Début`,
  END: `Fin`
}
